/**
 * @fileoverview GET handler for the "/engagement/report_dashboard/:dashboard_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardId } from "./constants";
import type { EngagementReportDashboardDashboardIdResult } from "./types";

export const getEngagementReportDashboardDashboardId = reactQueryFetcherAdapter(
  engagementReportDashboardDashboardId,
  (signal: AbortSignal, dashboardId: string): Promise<EngagementReportDashboardDashboardIdResult> => {
    return fetch(`/engagement/report_dashboard/${dashboardId}`, "GET", {}, { signal });
  }
);
